(() => {
  const FOCUS_SELECTOR = [
    '[autofocus]','a[href]','area[href]','button:not([disabled])','input:not([type=hidden]):not([disabled])',
    'select:not([disabled])','textarea:not([disabled])','[tabindex]:not([tabindex^="-"])'
  ].join(',');

  const lockScroll = () => { document.documentElement.style.scrollBehavior = 'auto'; document.body.dataset.cmScrollY = String(window.scrollY); document.body.style.top = `-${window.scrollY}px`; document.body.classList.add('cm-no-scroll'); };
  const unlockScroll = () => { const y = parseInt(document.body.dataset.cmScrollY || '0',10); document.body.classList.remove('cm-no-scroll'); document.body.style.top = ''; window.scrollTo(0, y); document.documentElement.style.scrollBehavior = ''; };

  const openModal = (id, opener=null) => {
    const dlg = document.getElementById(id);
    if (!dlg || dlg.nodeName !== 'DIALOG') return;
    dlg.dataset.cmOpener = opener ? '1' : '';
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open','');
    lockScroll();
    // Focus
    setTimeout(() => (dlg.querySelector('[autofocus]') || dlg.querySelector(FOCUS_SELECTOR) || dlg).focus(), 0);

    // Trap
    const focusables = Array.from(dlg.querySelectorAll(FOCUS_SELECTOR));
    const first = focusables[0], last = focusables[focusables.length - 1];
    dlg.addEventListener('keydown', dlg._cmTrap = (e) => {
      if (e.key !== 'Tab' || !focusables.length) return;
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dlg)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    dlg.addEventListener('close', () => { unlockScroll(); });
  };

  const closeModal = (dlg) => {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    unlockScroll();
    dlg.removeEventListener('keydown', dlg._cmTrap);
  };

  // Delegation: open / close
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cm-open]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn.getAttribute('data-cm-open'), openBtn);
      return;
    }
    const closeBtn = e.target.closest('[data-cm-close]');
    if (closeBtn) {
      const dlg = e.target.closest('dialog[data-cm]');
      closeModal(dlg);
    }
  });

  // ESC
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openDlg = document.querySelector('dialog[data-cm][open]');
    if (openDlg) closeModal(openDlg);
  });

  // URL-Hash (optional): #cm-id öffnet direkt
  window.addEventListener('DOMContentLoaded', () => {
    if (location.hash) {
      const dlg = document.querySelector(`dialog[data-cm]${location.hash}`);
      if (dlg) openModal(dlg.id);
    }
  });

  // Expose (optional)
  window.CMModal = { open: openModal, close: (id) => closeModal(document.getElementById(id)) };
})();
